export default __webpack_public_path__ + "static/media/solution_72.9000a438.svg";